import lokaliseTags from '../../shared/lokaliseTags';

export const CHANGE_EMAIL_HEADER = {
  menu: {
    leftMenu: {
      name: lokaliseTags.SSO_GENERAL_BACK,
      icon: 'back',
      mobile: true,
      desktop: false,
    },
  },
};
